import React from 'react';

const SettingsToggleRow = ({
  title,
  description,
  enabled,
  onToggle,
  disabled = false,
  embedded = false,
}) => (
  <div className={embedded ? '' : 'bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden'}>
    <div className={`${embedded ? '' : 'px-6 py-4'} flex items-center justify-between gap-4`.trim()}>
      <div className="min-w-0">
        <p className="font-medium text-gray-900">{title}</p>
        {description ? <p className="text-sm text-gray-500">{description}</p> : null}
      </div>
      <div className="flex items-center gap-3 flex-shrink-0">
        <span className="text-sm text-gray-500">{enabled ? 'Activo' : 'Inactivo'}</span>
        <button
          type="button"
          role="switch"
          aria-checked={enabled}
          onClick={onToggle}
          disabled={disabled}
          className={`relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-teal-500 focus:ring-offset-2 disabled:opacity-60 ${
            enabled ? 'bg-teal-600' : 'bg-gray-200'
          }`}
        >
          <span
            className={`pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out ${
              enabled ? 'translate-x-5' : 'translate-x-1'
            }`}
            aria-hidden
          />
        </button>
      </div>
    </div>
  </div>
);

export default SettingsToggleRow;
